import axios from 'axios'
export default {

  async add (category) {
    try {
      category.updated_at = Date.now()
      category.created_at = Date.now()
      delete category._id

      const response = await axios.post('categories/add', category)
      if (response.status === 200) {
        console.log('categoría agregada correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al agregar la categoría:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar la categoría:', error)
      return false
    }
  },

  async edit (category) {
    try {
      category.updated_at = Date.now()
      const response = await axios.patch('categories/update', category)
      if (response.status === 200) {
        console.log('categoría editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el categoría:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el categoría:', error)
      return false
    }
  },

  async listByBussines (businesId, search, page) {
    try {
      const response = await axios.get('categories/listByBusiness?business=' + businesId + '&search=' + search + '&page=' + page)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByPos (terminalId, search, page) {
    try {
      const response = await axios.get('categories/listByPos?terminal=' + terminalId + '&search=' + search + '&page=' + page)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async delete (obj) {
    try {
      obj.deleted_at = Date.now()
      const response = await axios.patch('categories/delete', obj)
      if (response.status === 200) {
        console.log('POS editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el pos:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el pos:', error)
      return false
    }
  },

  async listForOrder (terminalId) {
    try {
      const response = await axios.get('categories/categoriesForOrder?terminal=' + terminalId)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  }

}
